
import React, { useContext } from "react";
import { Form } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { RegulationContext } from "../../App";
import { LS_REGULATION_SELECTED_KEY } from "../../core/constants/common";
import useRegulationHelper from "../../core/hooks/useRegulationHelper";

function RegulationSelectBox({ t }) {

  const { glbRegulation, setGlbRegulation, glbRegulations } = useContext(RegulationContext); 
  const { navigateToPageAfterSelectingStandard } = useRegulationHelper();
 
  const handleChange = (e) => {
    localStorage.setItem(LS_REGULATION_SELECTED_KEY, e.target.value);
    let val = e.target.value;
    const found = glbRegulations.find((obj) => {
      return obj.id === parseInt(val);
    });
    navigateToPageAfterSelectingStandard(found);
    setGlbRegulation(found);
  };

  return (
    <>
      <Form>
        <select
          className="form-select "
          onChange={(e) => handleChange(e)}
          value={glbRegulation?.id ? glbRegulation.id : ""}>
          <option value="" disabled hidden>
            {t("Select.label")}
          </option>
          {glbRegulations?.map((item, index) => (
            <option value={item.id} key={item.id}>
              {item.name} {item.status=='DRAFT' && <>({item.status})</>}
            </option>
          ))}
        </select>
      </Form>
    </>
  );
}

export default withTranslation()(RegulationSelectBox);
